import React from 'react'
import {Link} from 'react-router-dom'

import PrivilegedContent from '@components/PrivilegedContent/PrivilegedContent'
import createArchiveContainer from '@components/Archive/createArchiveContainer'
import statuses from '@server/constants/statuses/user-statuses'
import { filterPresets } from '@modules/form/form.module'

import { ClientModel } from '@modules/user/user.module'

export const getTableColumns = () => ([
	{
		label: 'Status',
		prop: 'status',
		sortKey: 'status',
		getValue: (doc) => doc.status.label,
	},
	{
		label: 'Client ID',
		prop: 'clientID',
		sortKey: 'clientID',
	},
	{
		label: 'Client Name',
		sortKey: 'clientName',
		prop: 'clientName',
	},
	{
		label: 'Post Code',
		getValue: (doc) => doc.address ? doc.address.postCode : '',
		sortKey: 'address.postCode'
	}
]);

export const rowLinks = (doc) => (
	<React.Fragment>
		<Link className="TableRow-link" to={`/client/${doc.id}`}>view</Link>
		<Link className="TableRow-link" to={`/client/${doc.id}?edit=true`}>edit</Link>
		<PrivilegedContent permissions={['readAny:note']}>
			<Link className="TableRow-link" to={`/client/${doc.id}/notes`}>notes</Link>
		</PrivilegedContent>
	</React.Fragment>
);

export default createArchiveContainer({
	Model: ClientModel,
	title: 'Clients',
	queryConfig: {
		defaults: {
			sortBy: 'clientName',
		},
		filters: filterPresets([
			['status', {
				options: [
					{ label: 'All', value: 'any' },
					...statuses.map(s => ({
						label: s.label,
						value: s.order,
					})),
				],
			}],
			'search',
		]),
	},
	tableConfig: {
		columns: getTableColumns(),
		rowLinks: rowLinks,
	},
	// mapDataToCSV: (data) => {
	// 	console.log('Clients.mapDataToCSV');

	// 	const headers = ['Status', 'Payroll No.', 'Name', 'Industry', 'Postcode'];

	// 	const rows = data.map(d => [
	// 		d.status ? d.status.label : '', 
	// 		d.payrollNo, 
	// 		d.clientName, 
	// 		d.address ? d.address.postCode : '',
	// 	])

	// 	return [headers, ...rows];
	// },
});




// WEBPACK FOOTER //
// ./src/scenes/Clients/ClientListContainer.jsx